import Vue from 'vue'
import App from './App'
import router from './router'
import store from '@/store'
import Meta from 'vue-meta'
import '@/styles/table.scss'
import '@/core/lazy_use'
import '@/permission'
let personalData = Vue.prototype.$ls.get('personalSetting')
if (personalData && personalData.icon) {
  let iconImgSrc = personalData.icon
  if (iconImgSrc && iconImgSrc != '') {
    if (!iconImgSrc.includes('https')) {
      iconImgSrc = iconImgSrc.replace('http', 'https')
    }
    var link = document.querySelector("link[rel*='icon']") || document.createElement('link')
    link.type = 'image/x-icon'
    link.rel = 'shortcut icon'
    link.href = iconImgSrc
    document.getElementsByTagName('head')[0].appendChild(link)
  }
}

Vue.config.productionTip = false

Vue.prototype.$dictFil = (filArr, val) => {
  let filObj =
    _.find(filArr, (o) => {
      return o.valueId == val
    }) || {}
  return filObj.valueName || '-'
}
Vue.use(Meta)
//Vue.use(Calendar)
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app')
